<gs1-big-header
  [img]="'../assets/images/logo-gs1-france.png'"
  [breakWidth]="1080"
  [connected]="oauthService.hasValidAccessToken()"
  [showDisconnect]="false"
  [appName]="'Espace Adhérent'"
  [profileLabel]="'header.label' | translate"
>
  <div id="account-popin">
    <div class="utilisateur-info">
      <span class="name gs1-little">{{ contactFullName }}</span>
      <span class="email gs1-small">{{ contactEmail }}</span>
    </div>
    <a name="header-logout" class="gs1-little" (click)="logout()"><i class="bi bi-box-arrow-right"></i> {{ 'header.logout' | translate }}</a>
  </div>
</gs1-big-header>
<gs1-notifications></gs1-notifications>
